<template>
    <div>
        <ul class="list-item">
            <li class="w-20 list-item-col-end flex-column">
                <el-popover placement="right" trigger="hover">
                    {{cardItem.oid}}<span slot="reference">{{cardItem.oid | formatString(13)}}</span>
                </el-popover>
                <div v-if="brand">{{cardItem.company}}</div>
                <div v-else>{{cardItem.appoint_name || cardItem.product_name}}</div>
            </li>
            <li class="w-10 list-item-col-end">{{cardItem.date_in | formatTimestamp}}</li>
            <li class="w-30 list-item-col-end">{{OrderType}}</li>
            <li class="w-20 list-item-col-end">
                <span class="text-dark">{{cardItem.price}}&nbsp;/&nbsp;</span>
                <span class="text-success">{{(cardItem.price_pay / 100).toFixed(2)}}</span>
            </li>
            <li class="w-20 list-item-col-end" :class="$GFUN.FormatColor(cardItem.status)">
                {{cardItem.status | formatVar(orderStatusArr)}}
            </li>
            <li class="w-10 list-item-col-end">
                <span class="text-link" @click="$emit('goForDetail',cardItem)">查看详情</span>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'BrandOrderCard',
    props: {
      cardItem: {}
    },
    computed: {
        ...mapGetters(['storeInfo','brand']),
        orderStatusArr() {
            switch (this.storeInfo.type) {
            case 99:
            case 2: return 'TBOrderStatus';
            case 8: return 'BOrderStatus';
            default:return '';
            }
        },
        OrderType() {
            let arr = []
            if (this.getArr('room')) arr.push('房型')
            if (this.getArr('meeting')) arr.push('会议室')
            if (this.getArr('restaurant')) arr.push('餐饮')
            if (this.getArr('onsale')) arr.push('活动')
            if (this.getArr('itinerary')) arr.push('线路行程')
            return arr.join('/')
        }
    },
    methods: {
        getArr (type) { if (this.cardItem[type]) return this.cardItem[type].length > 0 }
    }
}
</script>